module.exports = __webpack_public_path__ + "img/He_Chuan.1e008dc0.png";